import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ShowCase } from 'src/app/api/models';
import { AppointmentStatus } from 'src/app/enums/appointment-status-enum';
import { ProductStatus } from 'src/app/enums/product-status-enum';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-dashboard-filter',
  templateUrl: './dashboard-filter.component.html',
  styleUrls: ['./dashboard-filter.component.scss']
})
export class DashboardFilterComponent implements AfterViewInit, OnChanges {

  @Input() showcases: any;
  @Input() salesRooms: Set<string> = new Set();

  @ViewChild('formRef') formRef!: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIfShowMoreAndLessButtonsShouldBeVisible();
  }


  selectSalesRooms: any;

  placeholderSearch = 'PAGES.FILTER.SEARCH_SAP_CODE';

  selectStatus = [
    ProductStatus.NOT_AVAILABLE,
    ProductStatus.AVAILABLE,
    ProductStatus.IN_APPOINTMENT,
    // ProductStatus.UNLOCK,
    ProductStatus.BOOKED_FOR_SALES,
    ProductStatus.BROKEN,
    ProductStatus.WEAR,
    ProductStatus.CLIENT_VIEW,
    ProductStatus.UNDER_NEGOTIATION
  ]

  appointmentStatus = [
    // AppointmentStatus.CREATED,
    AppointmentStatus.OPEN,
    AppointmentStatus.DONE,
    // AppointmentStatus.CLOSED,
    // AppointmentStatus.END
  ];

  @Output() applyFilters = new EventEmitter();
  @Output() resetFilters = new EventEmitter();

  searchFormControl = new FormControl('');
  // ---------------------------------------------
  appointmentFormControl = new FormControl('');
  statusFormControl = new FormControl('');
  roomsFormControl = new FormControl('');
  isBookedForSalesControl = new FormControl('');
  showCaseControl = new FormControl('');
  // ---------------------------------------------
  showcasesSelected: string[] = [];

  showMoreFilters: boolean = false;
  showMoreAndLessButtons: boolean = true;

  ngAfterViewInit(): void {
    this.checkIfShowMoreAndLessButtonsShouldBeVisible();
  }


  constructor(
    private translateService: TranslateService,
    public sharedService: SharedService
  ) { }

  apply() {
    const showcases: any = this.showCaseControl.value || '';
    const salesRoom: any = this.roomsFormControl.value || '';
    const statusAllocation = this.statusFormControl.value || '';
    const isBookedForSales = this.isBookedForSalesControl.value;
    const appointmentStatus = this.appointmentFormControl.value || '';
    const searchResult = this.searchFormControl.value?.trim() || '';

    let params: any = {}

    if (!!appointmentStatus) {
      params.AppointmentStatus = appointmentStatus;
    }
    if (!!statusAllocation) {
      params.Status = statusAllocation;
    }
    if (!!showcases) {
      params.AllocationCode = showcases;
    }
    if (!!salesRoom) {
      params.SalesRoomId = salesRoom.key;
    }
    if (isBookedForSales !== "") {
      params.IsBookedForSales = isBookedForSales;
    }

    this.applyFilters.emit({ search: searchResult, params: params });

  }

  translateSelectShowcase(sc: ShowCase) {
    let result = sc.description;
    if (sc.area) {
      result += " - " + sc.area;
    }
    return result;
  }

  reset() {
    this.searchFormControl = new FormControl('');
    // ---------------------------------------------
    this.showCaseControl = new FormControl('');
    this.appointmentFormControl = new FormControl('');
    this.statusFormControl = new FormControl('');
    this.roomsFormControl = new FormControl('');
    this.isBookedForSalesControl = new FormControl('');
    // ---------------------------------------------
    this.resetFilters.emit();
  }

  buildSelectSalesRoom() {
    this.selectSalesRooms = [];
    if (this.salesRooms) {
      (Array.from(this.salesRooms)).forEach((_sr: any) => {
        if (_sr) {
          this.selectSalesRooms.push(JSON.parse(_sr));
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.buildSelectSalesRoom();
  }

  getValueSalesRoom(sr: any): string {
    return sr.value;
  }

  checkIfShowMoreAndLessButtonsShouldBeVisible() {
    let widthSum = 0;
    try {
      let children = Array.prototype.slice.call(this.formRef.nativeElement.children);
      if (children.length === 1) {
        this.showMoreAndLessButtons = false;
        this.showMoreFilters = true;
      } else {
        children.forEach(elem => {
          //Aggiungo 16 per un offset approssimativo relativo al gap di "1em" del form
          widthSum += elem.offsetWidth + 16;
        });
        if (this.formRef.nativeElement.offsetWidth < widthSum && this.showMoreAndLessButtons === false) {
          this.showMoreAndLessButtons = true;
        } else if (this.formRef.nativeElement.offsetWidth > widthSum && this.showMoreAndLessButtons === true) {
          this.showMoreAndLessButtons = false;
        }

      }
    }
    catch (err) {
      console.log(err);
    }
  }

  showFilters(flag: boolean) {
    this.showMoreFilters = flag;
  }

}
